var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ProgressionAction, ProgressionFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { createSelector } from "@reduxjs/toolkit";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, } from "../../../../utils/questionnaireProgress";
var selectJobSeekerQuestionnaire = function (state) {
    return state.rootReducer.JobSeekerQuestionnaireReducer;
};
var selectUserData = function (state) { return state.rootReducer.userReducer; };
var selectQuestionnaireData = createSelector([selectJobSeekerQuestionnaire], function (questionnaire) { return ({
    progressionData: questionnaire.progressionData,
    progressionFormData: questionnaire.progressionFormData,
    status: questionnaire.status,
    success_progression_form: questionnaire.success_progression_form,
}); });
var selectLoginData = createSelector([selectUserData], function (userData) { return ({
    loginData: userData.loginData || "",
}); });
/**
 * The Progression Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function ProgressionQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(false), isSubmitting = _a[0], setIsSubmitting = _a[1];
    var _b = useSelector(selectQuestionnaireData), progressionData = _b.progressionData, progressionFormData = _b.progressionFormData, success_progression_form = _b.success_progression_form;
    var loginData = useSelector(selectLoginData).loginData;
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    useEffect(function () {
        console.log("[Progression] Component mounted, fetching data");
        questionnaireTimer.startSection("Your Path to Employment");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!progressionData || progressionData.length === 0) {
            dispatch(ProgressionAction());
        }
    }, [dispatch]);
    var handleFormSubmit = function (formData) {
        console.log("[Progression] Submitting form data:", formData);
        questionnaireTimer.endSection("Your Path to Employment");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] =
                typeof formData[key] === "string"
                    ? DOMPurify.sanitize(formData[key])
                    : formData[key];
            return acc;
        }, {});
        console.log("[Progression] Dispatching form action with sanitized data");
        setIsSubmitting(true);
        dispatch(ProgressionFormAction(sanitizedData, loginData));
    };
    var handleBackBtn = function () {
        console.log("[Progression] Navigating back to personal wellbeing");
        navigate("/questionnaire/personal_wellbeing");
    };
    useEffect(function () {
        console.log("[Progression] Success status changed:", success_progression_form);
        if (success_progression_form && isSubmitting) {
            console.log("[Progression] Form successful, navigating to global");
            navigate("/questionnaire/global");
        }
    }, [success_progression_form, isSubmitting, navigate]);
    console.log("[Progression] Rendering with data:", {
        hasData: !!(progressionData === null || progressionData === void 0 ? void 0 : progressionData.length),
        hasFormData: !!Object.keys(progressionFormData || {}).length,
        success: success_progression_form,
    });
    return (_jsx("div", __assign({ className: "" }, { children: _jsx(QuestionnaireOrg, { title: "Your Path to Employment", content: "", data: progressionData, responses: progressionFormData, loading: !progressionData || progressionData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "progression-w", width: getQuestionnaireProgressWidth("progression", getQuestionnaireAttemptVariant(quesAttemptDetails)) }) })));
}
export default ProgressionQuestionnaire;
